if ( $(".stats").length && !$("#watch").length ) {
  //- performance
  function updatePerfTables(locale) {
    $("#performance table")
      .removeClass("hidden")
      .addClass("hidden");
    $("#performance table." + locale).toggleClass("hidden");
    $(".footnotes").attr("data-locale", locale);
  }

  //- default
  function updateDefaultTables(locale) {
    $('#default table').removeClass('hidden').addClass('hidden');
    $('#default table.' + locale).toggleClass('hidden');
  }
  var filter;
  //- flag selectors + calculation filter scripts : see main.js
  //- on load
  $(function() {
    //- init calculation filter = 'vol' -> hide 'num' rows
    filter = 'vol';
    var overallTable = $('#performance .tables.perf table.overall');
    overallTable.find('tr:nth-child(4n+9):nth-child(-n+19) td, tr:nth-child(4n+10):nth-child(-n+20) td').addClass('hidden');
    var incidentTable = $('#performance .tables.perf table.incident');
    incidentTable.find('tr:nth-child(6n+5):nth-child(-n+11) td, tr:nth-child(6n+6):nth-child(-n+12) td').addClass('hidden');
    var defaultTable = $('#default .tables table.default');
    defaultTable.find('tr:nth-child(n+9) td').addClass('hidden');
    //- switch calculation filter
    $('.filter a.num, .filter a.vol').on('click', function (e) {
      e.preventDefault();
      filter = (filter === 'vol') ? 'num' : 'vol';
      $('.filter .vol').toggleClass('hidden');
      $('.filter .num').toggleClass('hidden');
      //- volume rows
      overallTable.find('tr:nth-child(4n+9):nth-child(-n+19) td, tr:nth-child(4n+10):nth-child(-n+20) td').toggleClass('hidden');
      incidentTable.find('tr:nth-child(6n-3):nth-child(-n+10) td, tr:nth-child(6n-2):nth-child(-n+10) td').toggleClass('hidden');
      defaultTable.find('tr:nth-child(n+9) td').toggleClass('hidden');

      //- number rows
      overallTable.find('tr:nth-child(4n+7):nth-child(-n+17) td, tr:nth-child(4n+8):nth-child(-n+18) td').toggleClass('hidden');
      incidentTable.find('tr:nth-child(6n+5):nth-child(-n+12) td, tr:nth-child(6n+6):nth-child(-n+12) td').toggleClass('hidden');
      defaultTable.find('tr:nth-child(n+5):nth-child(-n+8) td').toggleClass('hidden');
    });

    //- stripes all perf tables
    var overallTable = $('#performance .tables.perf table.overall');
    var incidentTable = $('#performance .tables.perf table.incident');
    $('#performance .tables.perf table tr:nth-child(4n+3) td, #performance .tables.perf table tr:nth-child(4n+4) td').addClass('striped');
    //- adapt stripes on the overall & the incident tables to fit with calculation filter / duplicated rows
    overallTable.find('tr:nth-child(n+9):nth-child(-n+27) td').toggleClass('striped');
    overallTable.find('tr:nth-child(n+13):nth-child(-n+16) td').toggleClass('striped');
    incidentTable.find('tr:nth-child(n+5):nth-child(-n+10) td').toggleClass('striped');

    //- STRIPES all crd tables
    $('#default .tables table tr:nth-child(4n+3) td, #default .tables table tr:nth-child(4n+4) td').addClass('striped');

    //- SMOOTH SCROLLING between footnotes & table labels' anchors
    $('table thead a[href^="#"], table tbody a[href^="#"], .footnotes a[href^="#"]').on('click', function (event) {
      event.preventDefault();
      //- footnotes href are completed with locales and calculation filter when needed
      if( $(this).parents('div').hasClass('footnotes') ) {
        if ($(this).parents('.footnote').hasClass('calcFilter')) {
          var target = $(this).attr('href') + '-' + $('.footnotes').attr('data-locale') + '-' + filter;
        } else {
          var target = $(this).attr('href') + '-' + $('.footnotes').attr('data-locale');
        }
      //- table labels' href are already build with php
      } else {
        var target = $(this).attr('href');
      }
      $('html, body').animate({
          scrollTop: ( ($(target).offset().top) - 144 )
        }, 'fast');
    });
  });

}
